import { api, createDeviceIsActiveUrl } from "@is/services/api";

type IsActiveResponse = {
  isActive: boolean;
};

type WaitForDeviceActiveOptions = {
  maxAttempts?: number;
  intervalMs?: number;
};

const DEFAULT_MAX_ATTEMPTS = 10;
const DEFAULT_INTERVAL_MS = 1000;

/**
 * Polls the /isactive endpoint until the device is reported active or
 * the attempt budget is exhausted. Used right after device registration
 * to wait for backend propagation before navigating the user onward.
 */
export const waitForDeviceActive = async (
  storeId: string,
  deviceId: string,
  { maxAttempts, intervalMs }: WaitForDeviceActiveOptions = {}
): Promise<boolean> => {
  const totalAttempts = maxAttempts ?? DEFAULT_MAX_ATTEMPTS;
  const delay = intervalMs ?? DEFAULT_INTERVAL_MS;
  const url = createDeviceIsActiveUrl(storeId, deviceId);

  for (let attempt = 0; attempt < totalAttempts; attempt++) {
    try {
      const response = (await api.get(url)) as IsActiveResponse;
      if (response?.isActive === true) {
        return true;
      }
    } catch {
      // ignore — treat as inactive and continue retrying
    }

    if (attempt < totalAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }

  return false;
};
